const DURATION_PATTERN = /^(\d{1,3}):([0-5]\d)$/;

const splitMinutes = (totalMinutes: number) => ({
  hours: Math.floor(totalMinutes / 60),
  minutes: totalMinutes % 60,
});

export const minutesToDuration = (totalMinutes: number): string => {
  const { hours, minutes } = splitMinutes(totalMinutes);
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};

export const durationToMinutes = (value: string): number | null => {
  const match = DURATION_PATTERN.exec(value.trim());
  if (!match) return null;
  return Number(match[1]) * 60 + Number(match[2]);
};

export const formatMinutesAsHoursAndMinutes = (totalMinutes: number): string => {
  const { hours, minutes } = splitMinutes(totalMinutes);
  return minutes === 0 ? `${hours}h` : `${hours}h ${minutes}m`;
};

export const describeMinutes = (totalMinutes: number): string => {
  const { hours, minutes } = splitMinutes(totalMinutes);
  const hoursText = `${hours} ${hours === 1 ? 'hour' : 'hours'}`;
  if (minutes === 0) return hoursText;
  return `${hoursText} ${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
};
